<template>
  <template v-if="id===customId">
    <Content
      v-for="(content, index) in contents"
      :key="index"
      :content="content"
    />
  </template>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import { useState } from '@/hooks/use_state';
import { ContentBase } from '@/models/content_base';

export default defineComponent({
  name: 'ContentTieUpConfirm',
  components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
  },
  props: {

    /**
     * コンテンツ
     */
    contents: {
      type: Array as PropType<ContentBase[]>,
      required: true,
    },
    customId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const state = useState();
    const id = state.value.id;
    return {
      id,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
